import React from 'react';
import './RandomCharView.css';
import { generateId } from '../../helpers';
import { string } from 'prop-types';

const RandomCharView = props => {
  const { name } = props

  return (
    <>
      <h4>Random Character: <br /> {name}</h4>
      <ul className="list-group list-group-flush">
        {['Gender', 'Born', 'Died', 'Culture'].map(title => (
          <li className="list-group-item d-flex justify-content-between" key={generateId()}>
            <span className="term">{title}</span>
            <span>{props[`${title.toLowerCase()}`]}</span>
          </li>
        ))}
      </ul>
    </>
  )
}

RandomCharView.propTypes = {
  name: string,
}

RandomCharView.defaultProps = {
  name: '',
}

export default RandomCharView